import { CollectionList } from '@/components/composed';

/**
 * CollectionsPage - Displays user's collections
 *
 * Routes:
 * - /collections (authenticated user's collections)
 * - /u/:username/collections (specific user's collections)
 *
 * TODO: Extract username param and fetch collections for specific user when implemented
 */
export function CollectionsPage() {
  return <CollectionList />;
}
